import PropTypes from 'prop-types'
import React from 'react'

const Icon = ({
  size = 18,
  name = 'cancel',
  className = 'nav-list-icon',
  title,
  style = {}
}) => {
  return (
    <svg className={className}
      width={size}
      height={size}
      title={title}
      name={name}
      style={style}
    >
      <use xlinkHref={`#icon-${name}`} />
    </svg>
  )
}

Icon.propTypes = {
  className: PropTypes.string,
  name: PropTypes.string,
  size: PropTypes.number,
  style: PropTypes.object,
  title: PropTypes.string,
}

export { Icon as default }



// WEBPACK FOOTER //
// ./src/shared/components/Icon.js